import React, { useEffect, useCallback, useMemo, useRef, useState, memo } from "react";

import Quill, { QuillOptions } from 'quill';
import 'quill/dist/quill.snow.css';
import Delta from 'quill-delta';
import katex from 'katex';
import 'katex/dist/katex.min.css';
window.katex = katex;

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, scale, onUpdate, actionEnd, userPermission, handleSelectClick, destroyThis, setCanCopy } = props;
  //
  const [textType, setTextType] = useState<string>("text");
  //  
  const quillRef = useRef<Quill | null>(null);
  const [Text, setText] = useState<string>(config.data.data?.content);
  const [hidePlaceholder, setHidePlaceholder] = useState(false);
  // 
  const marqueeRef = useRef<HTMLDivElement>(null);
  const [MarqueeText, setMarqueeText] = useState<string>(config.data.data?.marquee?.content? config.data.data?.marquee.content : "");
  const [MarqueeTextSize, setMarqueeTextSize] = useState<string>(config.data.data?.marquee?.fontSize? config.data.data?.marquee.fontSize : 20);
  const [paused, setPaused] = useState(false);
  const [offset, setOffset] = useState(0);
  const [scrollDirection, setScrollDirection] = useState<'left' | 'right'>('right');
  const [speed, setSpeed] = useState(1);
  const prevTextTypeRef = useRef<string>('text');
  // 
  const [isIPad, setIsIPad] = useState<boolean>( /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document));
  
  const iPadCheck = () => {
    const isIOS = /iPad/.test(navigator.userAgent) || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
    return isIOS;
  };
  
  useEffect(() => {
    if (iPadCheck()) {
      setIsIPad(true);
    } else {
      setIsIPad(false);
    }
  }, []);

  useEffect(() => {
    if (config.data && config.data.data?.content && config.data.data?.triggered) {
      setText(config.data.data.content);
      if (quillRef.current) {
        quillRef.current.clipboard.dangerouslyPasteHTML(config.data.data.content);
      }

      delete config.data.data.triggered;
    }
  }, [config.data.data?.content]);

  useEffect(() => {
    if (config.data && config.data.data?.type && config.data.data?.triggered) {
      setTextType(config.data.data.type);

      delete config.data.data.triggered;
    }
  }, [config.data.data?.type]);

  useEffect(() => {
    if (config.data && config.data.data?.marquee && config.data.data?.marquee.content && config.data.data?.triggered) {
      setMarqueeText(config.data.data.marquee.content);

      delete config.data.data.triggered;
    }
  }, [config.data.data?.marquee]);

  useEffect(() => {
    if (config.data && config.data.data?.marquee && config.data.data?.marquee.fontSize && config.data.data?.triggered) {
      setMarqueeTextSize(config.data.data.marquee.fontSize);

      delete config.data.data.triggered;
    }
  }, [config.data.data?.marquee]);

  useEffect(() => {
    if (config.data && config.data.data?.marquee && config.data.data?.marquee.direction && config.data.data?.triggered) {
      setScrollDirection(config.data.data.marquee.direction);

      delete config.data.data.triggered;
    }
  }, [config.data.data?.marquee]);

  useEffect(() => {
    if (config.data && config.data.data?.marquee && config.data.data?.marquee.speed && config.data.data?.triggered) {
      setSpeed(config.data.data.marquee.speed);

      delete config.data.data.triggered;
    }
  }, [config.data.data?.marquee]);

  useEffect(() => {
    if (config.data.data && config.data.data.marquee) {
      setTextType(config.data.data.type);
      setMarqueeText(config.data.data.marquee.content);
      setMarqueeTextSize(config.data.data.marquee.fontSize);
      setScrollDirection(config.data.data.marquee.direction);
      setSpeed(config.data.data.marquee.speed);

      
      if (config.data.data?.type === 'marquee' && prevTextTypeRef.current !== 'marquee' && marqueeRef.current) {
        const containerWidth = marqueeRef.current.offsetWidth;
        const direction = config.data.data.marquee.direction || 'right';
        const resetOffset = direction === 'left' ? containerWidth : -marqueeRef.current.scrollWidth;
        setOffset(resetOffset);
      }
      prevTextTypeRef.current = config.data.data?.type;
    }
  }, [
    config.data.data?.type,
    config.data.data?.marquee?.content,
    config.data.data?.marquee?.fontSize,
    config.data.data?.marquee?.direction,
    config.data.data?.marquee?.speed,
  ]);

  useEffect(() => {
    if (!config.selected || Text || MarqueeText) {
      const DATA = Text;
      const M_DATA = MarqueeText;
      const data = config.data.data;
      data.content = DATA;
      if (data.marquee) {
        data.marquee.content = M_DATA;
      }
      const listTitle = removeHtmlTags(Text);
      const update: any = { id: config.data.id, data: data };
      if (listTitle !== "") {
        update["listTitle"] = removeHtmlTags(Text);
      }
      if ((!username && !config?.data.studentName) || (username === config.data.studentName)) {
        onUpdate(update);
        actionEnd(true);
      }
    }
  }, [config.selected, Text, MarqueeText]);

  const removeHtmlTags = (text: string) => {
    return text.replace(/<[^>]*>/g, '');
  };

  const editorRef = useRef<any>(null);
  useEffect(() => {
    if (editorRef.current && !quillRef.current) {
      const Scope = Quill.import('parchment').Scope;
      const Size = Quill.import('attributors/style/size') as any;
      Size.whitelist = ['14px', '18px', '22px', '28px', '36px', '48px', '64px', '96px', '120px'];
      Quill.register(Size, true);
      const Font = Quill.import('attributors/style/font') as any;
      Font.whitelist = ['注音芫荽', 'Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'];
      Quill.register(Font, true);
      
      const options: QuillOptions = {
        modules: {
          toolbar: {
            container: `#external-toolbar_${config.data.id}`,
          },
          keyboard: {
            bindings: {
              handleEnter: {
                key: "Enter",
                handler: (range: any, context: any) => {
                  if (!quillRef.current) return;
                  const quillInstance = quillRef.current;
                  if (!quillInstance.scroll) return;

                  const lineFormats = Object.keys(context.format).reduce(
                    (formats, format) => {
                      if (
                        quillInstance.scroll.query(format, Scope.BLOCK) &&
                        !Array.isArray(context.format[format])
                      ) {
                        formats[format] = context.format[format];
                      }
                      return formats;
                    },
                    {} as Record<string, any>,
                  );

                  const delta = new Delta()
                    .retain(range.index)
                    .delete(range.length)
                    .insert("\n", lineFormats);
                  quillInstance.updateContents(delta, Quill.sources.USER);
                  quillInstance.setSelection(range.index + 1, Quill.sources.SILENT);
                  Object.keys(context.format).forEach((name) => {
                    if (lineFormats[name] != null) return;
                    if (Array.isArray(context.format[name])) return;
                    if (name === "code" || name === "link") return;
                    quillInstance.format(
                      name,
                      context.format[name],
                      Quill.sources.USER,
                    );
                  });
                },
              },
            },
          },
        },
        placeholder: '輸入內容...',
        theme: 'snow',
        readOnly: username !== config.data.studentName
      };
      const quill = new Quill(editorRef.current, options);
      quill.on('text-change', () => {
        const editorContent = quill.root.innerHTML;
        const plainText = quill.getText().trim();
        setText(editorContent);
        setMarqueeText(plainText);
      });
      // 監聽中文輸入
      quill.on('composition-start', () => {
        setHidePlaceholder(true);
      })
      quill.on('composition-end', () => {
        setHidePlaceholder(false);
      })
      quill.root.addEventListener("focus", () => {
        setCanCopy(false);
      });
      quill.root.addEventListener("blur", () => {
        setCanCopy(true);
      });
      quillRef.current = quill;

      if (Text) {
        quill.clipboard.dangerouslyPasteHTML(Text);
      }
    }
  }, [quillRef.current]);

  useEffect(() => {
    let animationFrameId: number;

    const step = () => {
      if (!paused && marqueeRef.current) {
        setOffset((prev) => {
          const contentWidth = marqueeRef.current!.scrollWidth;
          const containerWidth = marqueeRef.current!.offsetWidth;

          let newOffset =
            scrollDirection === 'left' ? prev - speed : prev + speed;

          // reset when scroll too far
          if (scrollDirection === 'left' && Math.abs(newOffset) > contentWidth) {
            newOffset = containerWidth;
          }
          if (scrollDirection === 'right' && newOffset > containerWidth) {
            newOffset = -contentWidth;
          }

          return newOffset;
        });
      }

      animationFrameId = requestAnimationFrame(step);
    };

    animationFrameId = requestAnimationFrame(step);

    return () => cancelAnimationFrame(animationFrameId);
  }, [paused, scrollDirection, speed]);

  // 拖曳控制
  const dragState = useRef<{ startX: number; startOffset: number } | null>(null);

  const handleMouseDown = (e: React.MouseEvent) => {
    dragState.current = { startX: e.clientX, startOffset: offset };
    setPaused(true);
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (dragState.current) {
      const deltaX = e.clientX - dragState.current.startX;
      setOffset(dragState.current.startOffset + deltaX);
    }
  };

  const handleMouseUp = () => {
    dragState.current = null;
    setPaused(false);
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="componentCore h-100 w-100" style={{ display: textType === 'text' ? 'block' : 'none' }}>
        <div className={`text-box h-100 w-100 ${hidePlaceholder? "text-hide-placeholder" : ""}`} style={{ cursor: 'text' }}>
          <div ref={editorRef} className="text-editor"></div>
        </div>
      </div>
      <div
        className="componentCore h-100 w-100"
        style={{ display: textType === 'marquee' ? 'block' : 'none' }}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onMouseDown={handleMouseDown}
      >
        <div className={`text-box h-100 w-100`}>
          <div
            className="marquee-content"
            ref={marqueeRef}
            style={{
              transform: `translateX(${offset}px)`,
              cursor: 'grab',
              fontSize: isIPad? (Number(MarqueeTextSize) * scale) : MarqueeTextSize
            }}
          >
            {MarqueeText}
          </div>
        </div>
      </div>
    </React.Fragment>
  );

};

export default memo(Index);